import React, { useContext, useState } from "react";
import { FaPlusCircle } from "react-icons/fa";
import { MdOndemandVideo } from "react-icons/md";
import { MdFormatListBulleted } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { GrLinkNext } from "react-icons/gr";
import { Context, Step } from "../../Context";
import { RiTextSnippet } from "react-icons/ri";
import { MdDashboardCustomize } from "react-icons/md";

interface Props {
    showStepSelection : boolean,
    setShowStepSelection : Function,
    addNewHover : boolean,
    setAddNewHover : Function,
    endScreenAdded : boolean,
    setEndScreenAdded : Function
}

export const emptyVideo : Step = {
    action : "video",
    video : {
        url : "",
        poster : "",
        showTimeLeft : false,
        timeLeftPersentage : 50,
        timeLeftText : "",
        CTAscreen : false,
        title : "",
        description : "",
        ctaText : "",
        videoStyle : {width : "100", borderRadius : "10"},
        textScreenStyle : {textAlign : "left", padding : "0", backgroundColor : ""},
        h1Style : {fontSize : "24", color : ""},
        pStyle : {fontSize : "16", color : ""},
        ctaStyle : {fontSize : "18", color : "", padding :"10", borderRadius : "10", backgroundColor : ""}
    }
}
let emptyForm : Step = {
    action : "form",
    form : {
        header : "Before you continue...",
        description : "Fill in your contact details to access the rest of the demo.",
        inputFields : undefined,
        emailResults : "",
        ctaText : "Continue",
        textScreenStyle : {textAlign : "left", padding : "0", backgroundColor : "#ffffff"},
        h1Style : {fontSize : "24", color : ""},
        pStyle : {fontSize : "18", color : ""},
        labelStyle : {fontSize : "16", color : ""},
        inputStyle : {with : "50", padding : "0", fontSize :"16", borderRadius : ""},
        ctaStyle : {fontSize : "18", color : "#ffffff", backgroundColor : "#000000", padding : "10", borderRadius : "10"}
    }
}
let emptyTextScreen : Step = {
    action : "textScreen",
    textScreen : {
        h1 : "Continue forwad",
        description : "Click the button below to continue your demo",
        ctaText : "Continue",
        textScreenStyle : {textAlign : "left", padding : "0", backgroundColor : "#ffffff"},
        h1Style : {fontSize : "24", color : ""},
        pStyle : {fontSize : "18", color : ""},
        ctaStyle : {fontSize : "18", color : "#ffffff", backgroundColor : "#000000", padding : "10", borderRadius : "10"}
    }
}

const emptyEndScreen : Step = {
    action : "end screen",
    thankYouPage : {
        h1 : "Thank you for completing your demo",
        description : "Create your own engaging lead funnels at cxtailor.com",
        ctaText : "",
        ctaUrl : "",
        textScreenStyle : {textAlign : "left", padding : "0", backgroundColor : "#ffffff"},
        h1Style : {fontSize : "24", color : ""},
        pStyle : {fontSize : "18", color : ""},
        ctaStyle : {fontSize : "18", color : "#ffffff", backgroundColor : "#000000", padding : "10", borderRadius : "10"}
    }
}
const emptyTailoring : Step = {
    action : "tailored",
    tailored: {
        header : "Get a tailored demo",
        description : "Get your own tailored demo by selecting which topics are important to you",
        ctaString : "Start Demo",
        topicString : "Topics",
        selectAllString : "Select all",
        importanceStrings : ["Very important", "Somewhat important", "Not important"],
        questions : [],
        textScreenStyle : {textAlign : "left", padding : "0", backgroundColor : ""},
        h1Style : {fontSize : "25", color : ""},
        pStyle : {fontSize : "18", color : ""},
        ctaStyle : {fontSize : "18", color : "", padding :"10", borderRadius : "10", backgroundColor : ""},
        tableStyle : {titleFont : "18", titleColor : "", textFont : "16", textColor : "", backgroundColor : ""}
    }
}

const StepSelectionModal = ({showStepSelection, setShowStepSelection, addNewHover, setAddNewHover, endScreenAdded, setEndScreenAdded}:Props) : React.ReactElement => {
    const {steps, setSteps} = useContext(Context);
    const [videoHover, setVideoHover] = useState<boolean>(false);
    const [formHover, setFormHover] = useState<boolean>(false);
    const [tailorHover, setTailorHover] = useState<boolean>(false);
    const [endHover, setEndHover] = useState<boolean>(false);
    const [textScreenHover, setTextScreenHover] = useState<boolean>(false);


    return(
        <div className="flex flex-col justify-center items-center">
            <p className={`${(addNewHover && !endScreenAdded)?"":"invisible"} text-xl transition`}>Add new step</p>
            <FaPlusCircle className={`size-10 ${(!endScreenAdded)?"text-green hover:scale-105":"text-neutral-700"} cursor-pointer transition`} 
            onMouseEnter={()=>{setAddNewHover(true)}} onMouseLeave={()=>{setAddNewHover(false)}} onClick={()=>{if(!endScreenAdded){setShowStepSelection(true)}}}/>

            <input type="checkbox" checked={showStepSelection} id="stepSelection" className="modal-toggle" readOnly/>
            <div className="modal" role="dialog">
                <div className="modal-box flex flex-col justify-start items-start gap-3 relative">
                    <p className="text-2xl">Add a new step</p>
                    <p className="text-md">Select a new step to add to your funnel.</p>
                    <div className="
                    p-2 flex flex-row justify-start items-center gap-2 
                    cursor-pointer transition-all
                    border-[1px] border-brandPurple rounded-xl w-full 
                    hover:bg-brandPurple hover:text-white text-brandPurple
                    "
                    onMouseEnter={()=>{setVideoHover(true)}} onMouseLeave={()=>{setVideoHover(false)}}
                    onClick={()=>{setShowStepSelection(false); if(steps){
                        setSteps([...steps, JSON.parse(JSON.stringify(emptyVideo))])
                        }else{
                            setSteps([JSON.parse(JSON.stringify(emptyVideo))])
                        }}}>
                        <div>
                            <MdOndemandVideo className="size-14"/>
                        </div>
                        <div>
                            <p className="text-lg">Video Step</p>
                            <p className={`text-xs ${(videoHover)?"":"text-white"} transition-all`}>Add engaging video steps to capture your visitors focus.</p>
                        </div>
                    </div>

                    <div className="
                    p-2 flex flex-row justify-start items-center gap-2 
                    cursor-pointer transition-all
                    border-[1px] border-brandPurple rounded-xl w-full
                    hover:bg-brandPurple hover:text-white text-brandPurple
                    "
                    onMouseEnter={()=>{setFormHover(true)}} onMouseLeave={()=>{setFormHover(false)}}
                    onClick={()=>{setShowStepSelection(false); if(steps){
                        setSteps([...steps, JSON.parse(JSON.stringify(emptyForm))])
                        }else{
                            setSteps([JSON.parse(JSON.stringify(emptyForm))])
                        }}}>
                        <div>
                            <MdFormatListBulleted className="size-14"/>
                        </div>
                        <div>
                            <p className="text-lg">Form Step</p>
                            <p className={`text-xs ${(formHover)?"":"text-white"} transition-all`}>Collect leads & contact details.</p>
                        </div>
                    </div>
                    <div className="
                    p-2 flex flex-row justify-start items-center gap-2 
                    cursor-pointer transition-all
                    border-[1px] border-brandPurple rounded-xl w-full
                    hover:bg-brandPurple hover:text-white text-brandPurple
                    "
                    onMouseEnter={()=>{setTextScreenHover(true)}} onMouseLeave={()=>{setTextScreenHover(false)}}
                    onClick={()=>{setShowStepSelection(false); if(steps){
                        setSteps([...steps, JSON.parse(JSON.stringify(emptyTextScreen))])
                        }else{
                            setSteps([JSON.parse(JSON.stringify(emptyTextScreen))])
                        }}}>
                        <div>
                            <RiTextSnippet className="size-14"/>
                        </div>
                        <div>
                            <p className="text-lg">Text Screen</p>
                            <p className={`text-xs ${(textScreenHover)?"":"text-white"} transition-all`}>Text screen with simple CTA with no URL redirects</p>
                        </div>
                    </div>
                    <div className="
                    p-2 flex flex-row justify-start items-center gap-2 
                    cursor-pointer transition-all
                    border-[1px] border-brandPurple rounded-xl w-full
                    hover:bg-brandPurple hover:text-white text-brandPurple
                    "
                    onMouseEnter={()=>{setTailorHover(true);}} onMouseLeave={()=>{setTailorHover(false)}}
                    onClick={()=>{setShowStepSelection(false); if(steps){
                        setSteps([...steps, JSON.parse(JSON.stringify(emptyTailoring))])
                        }else{
                            setSteps([JSON.parse(JSON.stringify(emptyTailoring))])
                        }}}>
                        <div>
                            <MdDashboardCustomize className="size-14"/>
                        </div>
                        <div>
                            <p className="text-lg">Tailored demo</p>
                            <p className={`text-xs ${(tailorHover)?"":"text-white"} transition-all`}>Allow your visitors to Tailor the content of their demos</p>
                        </div>
                    </div>    
                    <div className="
                    p-2 flex flex-row justify-start items-center gap-2 
                    cursor-pointer transition-all
                    border-[1px] border-brandPurple rounded-xl w-full
                    hover:bg-brandPurple hover:text-white text-brandPurple
                    "
                    onMouseEnter={()=>{setEndHover(true)}} onMouseLeave={()=>{setEndHover(false)}}
                    onClick={()=>{setEndScreenAdded(true); setShowStepSelection(false); if(steps){
                        setSteps([...steps, JSON.parse(JSON.stringify(emptyEndScreen))])
                        }else{
                            setSteps([JSON.parse(JSON.stringify(emptyEndScreen))])
                        }}}>
                        <div>
                            <GrLinkNext className="size-14"/>
                        </div>
                        <div>
                            <p className="text-lg">End Screen</p>
                            <p className={`text-xs ${(endHover)?"":"text-white"} transition-all`}>Drive follow up steps after your funnel.</p>
                        </div>
                    </div>
                    <RxCross2 className="absolute top-2 right-2 size-8 cursor-pointer" onClick={()=>{setShowStepSelection(false);}}/>
                </div>
            </div>
        </div>
    );
};

export default StepSelectionModal;